<template>
  <el-dialog
    :visible.sync="dialogShow"
    :append-to-body="true"
    top="50px"
    custom-class="dialog-setting-skill"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close', false)"
  >
    <div slot="title">
      <h3 class="skill-title">{{$t('upgrade_page_layout_nav_48')}}</h3>
      <p>{{$t('upgrade_page_layout_setting_skill_1956')}}</p>
      <div class="my-skill-list">
        <div
          class="my-skill-box"
          v-for="(item, index) in dialogGames"
          :key="index + 'n'"
          @click="mySkillHandle(item)"
        >
          <span>{{ item.name }}</span>
          <i class="skill-remove-icon el-icon-minus" v-if="isEdit" @click="changeActive(item)"></i>
        </div>
        <div class="my-skill-box" v-if="!isEdit" @click="isEdit=true">
          <span>{{$t('upgrade_page_layout_setting_skill_1957')}}</span>
          <i class="skill-add-icon el-icon-plus"></i>
        </div>
      </div>
    </div>
    <h3 class="skill-title">{{$t('upgrade_page_layout_nav_50')}}</h3>
    <div v-for="[title, list] of allGamesAry" :key="title" class="game-wrap">
      <div class="title">{{ title | gameCategory }}</div>
      <ul class="game-list">
        <li
          v-for="item in list"
          :key="item.id"
          class="game-item"
          :class="{ active: myGamesId.includes(item.id)&&isEdit }"
          @click="changeActive(item)"
        >
          <div class="img">
            <img :src="item.imageUrl + '?d=300x300'" />
            <i v-if="isEdit" :class="myGamesId.includes(item.id) ? 'skill-remove-icon el-icon-minus':'skill-add-icon el-icon-plus'"></i>
          </div>
          <div class="name">
            <p>{{ item.name }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div slot="footer" v-if="isEdit">
      <button @click="handleSubmit" :class="{ disabled: loading }">{{$t('upgrade_page_views_player_list_index_182')}}</button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';

export default {
  model: {
    prop: 'show',
    event: 'close'
  },
  data() {
    return {
      dialogShow: false,
      loading: false,
      allGamesAry: [],
      myGamesId: [],
      dialogGames: [],
      isEdit: false // 是否是編輯常用技能中
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['allGames', 'myGames'])
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogShow = true;
        this.allGamesAry = Object.entries(this.allGames);
        this.myGamesId = this.myGames.map(item => item.id);
        this.dialogGames = [...this.myGames]
      } else {
        this.isEdit = false
      }
    }
  },
  methods: {
    changeActive(item) {
      if(!this.isEdit) {
        this.goPlayerList(item)
        return
      }
      const index = this.myGamesId.indexOf(item.id);
      if (index === -1) {
        // 添加
        if (this.myGamesId.length > 9) {
          this.$message.warning(i18n.t('upgrade_page_views_player_list_index_204'));
          return;
        }
        this.myGamesId.push(item.id);
        this.dialogGames.push(item)
      } else {
        // 移除
        this.myGamesId.splice(index, 1);
        this.dialogGames.splice(index, 1);
      }
    },
    mySkillHandle(item) {
      if(!this.isEdit) this.goPlayerList(item)
    },
    goPlayerList(item) {
     this.$router.push({ path:'/player-list/' + item.id })
     this.dialogShow = false
     this.$emit('close', false)
    },
    handleSubmit() {
      if (this.loading) return;
      this.loading = true;
      this.$http
        .post('/game/userCustom/save', {
          gameIds: this.myGamesId
        })
        .then(({ code }) => {
          if (code == 200) {
            this.$store.dispatch('app/getGamesList').then(() => {
              this.isEdit = false;
              this.loading = false;
            });
          } else {
            this.loading = false;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-setting-skill {
  @include flex(flex-start, stretch, column);
  width: 895px;
  max-height: 80vh;
  .el-dialog {
    &__header {
      padding: 48px 60px 16px;
      h3 {
        line-height: 28px;
        color: $color-gray-1;
        font-size: 20px;
        font-weight: 600;
      }
      p {
        margin-top: 4px;
        line-height: 20px;
        color: $color-gray-3;
        font-size: 14px;
      }
    }
    &__body {
      padding: 0 60px;
      flex-grow: 1;
      overflow-y: auto;
    }
    &__footer {
      @include flex(flex-end);
      padding: 16px 32px;
      border-top: 1px solid $color-split;
      flex-shrink: 0;
      button {
        @include flex;
        width: 176px;
        height: 48px;
        flex-shrink: 0;
        border-radius: 48px;
        font-size: 16px;
        font-weight: 500;
        @include button-yellow;
      }
    }
  }
  .game-wrap {
    padding-bottom: 28px;
    .title {
      padding: 8px 0;
      line-height: 20px;
      color: $color-gray-1;
      font-size: 14px;
      font-weight: 500;
    }
    .game-list {
      @include flex(flex-start);
      flex-wrap: wrap;
      margin: 0 -4px;
    }
    .game-item {
      @include flex(flex-start, stretch, column);
      position: relative;
      margin: 0 4px 12px;
      width: 120px;
      height: 188px;
      background: #f8f8f8;
      border-radius: 6px;
      cursor: pointer;
      .img {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-top: 100%;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: auto;
          transform: translate(-50%, -50%);
          transition: transform 0.2s;
        }
      }
      .name {
        padding: 8px;
        line-height: 20px;
        color: $color-gray-2;
        font-size: 14px;
      }
      &:hover {
        .img img {
          transform: translate(-50%, -50%) scale(1.14);
        }
      }
      &.active {
        background: #fab93c;
        .name {
          color: #fff;
        }
        &::after {
          box-sizing: content-box;
          content: '';
          position: absolute;
          z-index: 1;
          left: -2px;
          top: -2px;
          width: 100%;
          height: 100%;
          border: 2px solid #fab93c;
          border-radius: 6px;
        }
      }
    }
  }
}
.skill-title {
  line-height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: #222C43;
}
.my-skill-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 12px;
}
.my-skill-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 48px;
  margin:0 8px 8px 0;
  overflow: hidden;
  background: #F1F4F6;
  border-radius: 6px;
  color: #636D86;
  font-size: 14px;
  cursor: pointer;
  &:nth-child(6n) {
    margin-right: 0;
  }
  &:hover {
    background: #E8EAEE;
  }
}
.skill-remove-icon,
.skill-add-icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  right: 0;
  top: 0;
  border-radius: 0 6px 0 6px;
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
}
.skill-remove-icon {
  background: #636d86;
}
.skill-add-icon {
  background: #007aff;
}

@media screen and (max-width: 599px) {
  .dialog-setting-skill {
    width: 100%;
    height: 80vh;
    margin-top: 20vh !important;
    .el-dialog {
      &__header {
        padding: 24px 24px 8px;
      }
      &__body {
        padding: 0 20px;
      }
      &__footer {
        flex-shrink: 0;
        padding: 8px 24px;
      }
    }
    .game-wrap {
      .game-item {
        width: calc(33.3% - 8px);
      }
    }
  }
}
</style>
